export enum PackageType {
    ALL = 1,
    SPECIFIC = 2,
}

